module.exports = __webpack_public_path__ + "static/team_04-d4500e5318c15bf8fba2e26a926228f8.png";